import {
  FaFacebookF,
  FaInstagram,
  FaWhatsapp,
  FaTiktok,
  FaPaypal,
  FaCreditCard,
} from "react-icons/fa";

import logo from "../../assets/footer1.png";
import TopBanner from "../Header/TopBanner";

export default function Footer() {
  const socialLinks = [
    {
      icon: <FaFacebookF />,
      link: "https://www.facebook.com/share/1L1kmKw66C/?mibextid=wwXIfr",
      label: "Facebook",
    },
    {
      icon: <FaInstagram />,
      link: "https://www.instagram.com/a1rugss?igsi=MW56MWpqdmRkem0y",
      label: "Instagram",
    },
    {
      icon: <FaWhatsapp />,
      link: "https://wa.me/14259546183",
      label: "WhatsApp",
    },
    {
      icon: <FaTiktok />,
      link: "#",
      label: "TikTok",
    },
  ];

  return (
    <>
      <TopBanner />

      <footer className="bg-[#F7F1E3] text-[#2F241D] border-t border-[#E4D6BF]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-8 md:py-10">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-x-6 gap-y-7 md:gap-8">
            <div className="col-span-2 md:col-span-1 text-center md:text-left">
              <img
                src={logo}
                alt="A1 Rugs"
                className="h-20 sm:h-24 md:h-24 w-auto mx-auto md:mx-0 mb-4"
              />

              <p className="text-xs sm:text-sm leading-6 text-[#756556] max-w-sm mx-auto md:mx-0">
                A1 Rugs brings carefully selected handmade Afghan rugs to homes
                with a focus on quality, craftsmanship, timeless design, and
                authentic character.
              </p>

              <div className="flex justify-center md:justify-start gap-2.5 mt-4">
                {socialLinks.map((item, index) => (
                  <a
                    key={index}
                    href={item.link}
                    target={item.link !== "#" ? "_blank" : undefined}
                    rel={item.link !== "#" ? "noopener noreferrer" : undefined}
                    aria-label={item.label}
                    className="w-9 h-9 rounded-full bg-[#FFFDF8] border border-[#E4D6BF] shadow-sm flex items-center justify-center text-[#6B4F3A] hover:bg-[#0F766E] hover:text-white hover:border-[#0F766E] transition-all duration-200"
                  >
                    {item.icon}
                  </a>
                ))}
              </div>
            </div>

            <div>
              <h3 className="font-semibold uppercase tracking-wider mb-4 text-xs sm:text-sm text-[#2F241D]">
                Shop Rugs
              </h3>
              <ul className="space-y-2 text-xs sm:text-sm text-[#756556]">
                <li><a href="/products/All" className="hover:text-[#0F766E] transition">All Rugs</a></li>
                <li><a href="/products/Handmade Rugs" className="hover:text-[#0F766E] transition">Handmade Rugs</a></li>
                <li><a href="/products/Vintage Rugs" className="hover:text-[#0F766E] transition">Vintage Rugs</a></li>
                <li><a href="/products/New Arrivals" className="hover:text-[#0F766E] transition">New Arrivals</a></li>
                <li><a href="/products/Best Sellers" className="hover:text-[#0F766E] transition">Best Sellers</a></li>
              </ul>
            </div>

            <div>
              <h3 className="font-semibold uppercase tracking-wider mb-4 text-xs sm:text-sm text-[#2F241D]">
                Customer Care
              </h3>
              <ul className="space-y-2 text-xs sm:text-sm text-[#756556]">
                <li><a href="/contact" className="hover:text-[#0F766E] transition">Contact Us</a></li>
                <li><a href="#" className="hover:text-[#0F766E] transition">Shipping & Delivery</a></li>
                <li><a href="#" className="hover:text-[#0F766E] transition">Returns</a></li>
                <li><a href="#" className="hover:text-[#0F766E] transition">FAQ</a></li>
                <li><a href="#" className="hover:text-[#0F766E] transition">Track Order</a></li>
              </ul>
            </div>

            <div className="col-span-2 md:col-span-1">
              <h3 className="font-semibold uppercase tracking-wider mb-4 text-xs sm:text-sm text-[#2F241D]">
                Contact
              </h3>
              <div className="space-y-2.5 text-xs sm:text-sm text-[#756556]">
                <p>
                  <span className="font-medium text-[#2F241D]">Address</span><br />
                  10821 8th AVE<br />
                  Seattle, WA
                </p>

                <p>
                  <span className="font-medium text-[#2F241D]">Email</span><br />
                  <a href="mailto:info@shopa1rugs.com" className="hover:text-[#0F766E] transition">
                    info@shopa1rugs.com
                  </a>
                </p>

                <p>
                  <span className="font-medium text-[#2F241D]">Phone / WhatsApp</span><br />
                  <a href="tel:+14259546183" className="hover:text-[#0F766E] transition">
                    +1 (425) 954-6183
                  </a>
                </p>

                <a
                  href="https://wa.me/14259546183"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 hover:text-[#0F766E] transition"
                >
                  <FaWhatsapp />
                  Chat with us on WhatsApp
                </a>
              </div>
            </div>
          </div>

          <div className="mt-7 md:mt-8 pt-5 border-t border-[#E4D6BF] flex flex-col sm:flex-row justify-between items-center gap-4">
            <div>
              <p className="text-xs sm:text-sm text-[#756556]">
                Secure shopping & trusted payments
              </p>
              <p className="mt-1 text-[11px] text-[#8A7B6C]">
                Your payment is securely processed through PayPal or Stripe.
              </p>
            </div>

            <div className="flex items-center gap-2">
              <div className="flex items-center gap-2 rounded-lg border border-[#E4D6BF] bg-[#FFFDF8] px-4 py-2 shadow-sm text-sm font-semibold text-[#003087]">
                <FaPaypal className="text-lg" />
                <span>PayPal</span>
              </div>

              <div className="flex items-center gap-2 rounded-lg border border-[#E4D6BF] bg-[#FFFDF8] px-4 py-2 shadow-sm text-sm font-semibold text-[#0F766E]">
                <FaCreditCard className="text-lg" />
                <span>Cards</span>
              </div>
            </div>
          </div>
        </div>

        <div className="bg-[#EDE2CF] py-3">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 flex flex-col sm:flex-row justify-between items-center gap-2 text-xs sm:text-sm text-[#756556]">
            <p>© 2026 A1 Rugs. All rights reserved.</p>
            <div className="flex gap-4">
              <a href="#" className="hover:text-[#0F766E] transition">Privacy</a>
              <a href="#" className="hover:text-[#0F766E] transition">Terms</a>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}
